module.exports = __webpack_public_path__ + "./img/paused_headphones_off.png";